(function () {
  if (window.tdmCardImagesInit) return;
  window.tdmCardImagesInit = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function promote(img) {
    if (!img || !img.dataset.srcset) return;
    img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
  }

  function promotePair(pair, withHover) {
    if (!pair) return;
    promote(pair.querySelector('.tdm-card-image--base'));
    if (withHover) promote(pair.querySelector('.tdm-card-image--hover'));
  }

  // Mouse users pay for the hover image only on the card they point at.
  if (canHover) {
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('.card-wrapper');
      if (!card) return;
      promotePair(card.querySelector('.tdm-card-image-pair.is-active'), true);
    });
  }

  // Keeps the image, the price, the add-to-cart form and every
  // "view product" link in sync with the variant the shopper just picked
  // in our own <select> — none of this happens on its own since the
  // card's <select> isn't a real variant-picker component.
  function applyVariant(card, variantId) {
    var select = card.querySelector('.variant-select');
    if (!select) return;
    var option = select.querySelector('option[value="' + variantId + '"]');
    if (!option) return;

    if (select.value !== variantId) select.value = variantId;

    // tdm-card-product's single swappable <img> — no pairs, no promoting,
    // just point it at the picked variant's own image.
    var cardImg = card.querySelector('[data-card-image]');
    if (cardImg && option.dataset.image) {
      cardImg.src = option.dataset.image;
      if (option.dataset.imageSrcset) cardImg.srcset = option.dataset.imageSrcset;
    }

    // card-product's older multi-pair stack, kept for the cards still
    // using it: swap which pair is active and promote its lazy image.
    var pair = card.querySelector('.tdm-card-image-pair[data-vid="' + variantId + '"]');
    if (pair && !pair.classList.contains('is-active')) {
      promotePair(pair, canHover);
      var activePair = card.querySelector('.tdm-card-image-pair.is-active');
      if (activePair && activePair !== pair) activePair.classList.remove('is-active');
      pair.classList.add('is-active');
    }

    if (option.dataset.url) {
      card.querySelectorAll('[data-product-link]').forEach(function (link) {
        link.href = option.dataset.url;
      });
    }

    if (option.dataset.price) {
      card.querySelectorAll('.tdm-card__price, .tdm-card__hover-price').forEach(function (priceEl) {
        priceEl.innerHTML = option.dataset.price;
      });
    }

    var form = select.closest('form');
    if (form) {
      var idInput = form.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variantId;

      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = option.disabled;
    }
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.variant-select');
    if (!select) return;
    var card = select.closest('.card-wrapper');
    if (!card) return;
    applyVariant(card, select.value);
  });

  // Keyboard focus is intent on any device.
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card) return;
    promotePair(card.querySelector('.tdm-card-image-pair.is-active'), canHover);
  });

  // Safety net: any other code (a swatch app, a theme script) that flips
  // .is-active gets its image loaded too, so a switched pair is never blank.
  // Watches the whole document because this script runs while the first card
  // is still being parsed, so no pair exists to observe individually yet.
  function watchPairs() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        var el = record.target;
        if (
          el.classList &&
          el.classList.contains('tdm-card-image-pair') &&
          el.classList.contains('is-active')
        ) {
          promotePair(el, canHover);
        }
      });
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  // A "variant on collection" app can decide a different variant should
  // represent this product on this particular collection page. It reliably
  // updates the image, price, title, links and this hidden add-to-cart
  // input's "value" attribute for that variant — but it has no idea our
  // card also has a <select>, so it never touches it. Left alone, the
  // dropdown keeps showing the original variant while everything else on
  // the card points at the app's chosen one. The hidden input's attribute
  // is the one reliable signal of what the app actually picked; we only
  // follow it to keep the select honest, nothing else — the app already
  // owns the image/price/links.
  //
  // Deliberately narrow to avoid the perf trap of watching the whole
  // document: one attribute observer per existing hidden input (not a
  // document-wide subtree watch), plus a direct-children-only watch on
  // each grid so a newly inserted card (the app builds size-specific
  // siblings by cloning one) gets picked up once, cheaply.
  function syncSelectToVariant(card) {
    var input = card.querySelector('[data-variant-id]');
    var select = card.querySelector('.variant-select');
    if (!input || !select) return;
    var variantId = input.getAttribute('value');
    if (variantId && select.value !== variantId) select.value = variantId;
  }

  function watchVariantSelectSync() {
    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          var card = record.target.closest && record.target.closest('.card-wrapper');
          if (card) syncSelectToVariant(card);
          return;
        }
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var newCards = node.matches('.card-wrapper') ? [node] : node.querySelectorAll('.card-wrapper');
          newCards.forEach(function (newCard) {
            syncSelectToVariant(newCard);
            watchInput(newCard);
          });
        });
      });
    });

    function watchInput(card) {
      var input = card.querySelector('[data-variant-id]');
      if (input) observer.observe(input, { attributes: true, attributeFilter: ['value'] });
    }

    var cards = document.querySelectorAll('.card-wrapper');
    var grids = new Set();
    cards.forEach(function (card) {
      syncSelectToVariant(card);
      watchInput(card);
      var grid = card.parentElement && card.parentElement.parentElement;
      if (grid) grids.add(grid);
    });
    grids.forEach(function (grid) {
      observer.observe(grid, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchPairs();
      watchVariantSelectSync();
    });
  } else {
    watchPairs();
    watchVariantSelectSync();
  }
})();
